import gql from 'graphql-tag';

export const findingAidsSeriesQuery = gql`
  query getFindingAidsSeries($slug: ID!) {
    findingAidsSeries(id: $slug, idType: SLUG) {
      collection {
        callNumber
        series {
          title
          slug
        }
        title
      }
      content
      files {
        box
        collection
        depth
        folder
        label
        id
        phystech
        slug
        type
        uid
        unitdate
        unittitle
      }
      subseries {
        label
        files {
          box
          collection
          depth
          folder
          label
          id
          phystech
          slug
          type
          uid
          unitdate
          unittitle
        }
      }
      seriesData {
        date_label
        volume
      }
      title
      slug
    }
  }
`;
